const INIT_TIMER = 'INIT_TIMER';
const RESET_TIMER = 'RESET_TIMER';

export const PURGE_DATA = 'PURGE_DATA';

const initialState = {
  start: new Date().getTime(),
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_TIMER: {
      return { start: new Date().getTime() };
    }

    default:
      return state;
  }
};

export const initTimer = {
  type: INIT_TIMER,
};

export const resetTimer = {
  type: RESET_TIMER,
};

export const purgeData = {
  type: PURGE_DATA,
};

export default reducer;
